import { Box, SimpleGrid, VStack } from '@chakra-ui/react';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import React from 'react';
import { SectionHeader } from '../common/SectionHeader';

type NearbyStoresProps = {
  children?: React.ReactNode;
};

type ColumnsMode = 'single' | 'multiple';

export const NearbyStores: React.FC<NearbyStoresProps> = () => {
  const { property } = usePropertiesModel();
  const storesCount = property?.sfr?.info.nearby_stores?.length ?? 0;
  const displayMode: ColumnsMode = storesCount > 1 ? 'multiple' : 'single';
  const columns: Record<ColumnsMode, number[]> = {
    multiple: [1, 2, 3, 4],
    single: [1],
  };
  const dim: Record<ColumnsMode, [width: string, height: string]> = {
    multiple: ['150px', '65px'],
    single: ['100%', '130px'],
  };
  return (
    <VStack alignItems={['center', 'flex-start']}>
      <Box alignSelf={['center', 'flex-start']} mb={['20px', '40px']}>
        <SectionHeader text={'Nearby Stores'} />
      </Box>
      <SimpleGrid
        w={['150px', 'full']}
        columns={columns[displayMode]}
        gap={['20px', '30px']}
        alignItems={['center', 'flex-start']}>
        {property?.sfr?.info.nearby_stores?.map((store, i) => (
          <Box
            maxW="150px"
            key={`store-${i}`}
            h={dim[displayMode][1]}
            backgroundImage={store.url}
            backgroundSize="contain"
            backgroundRepeat={'no-repeat'}
            backgroundPosition="center center"></Box>
        ))}
      </SimpleGrid>
    </VStack>
  );
};
